import React, {useEffect, useState} from 'react';
import {Button, FormControl, FormControlLabel, Grid, MenuItem, Select, Switch} from '@material-ui/core'
import {DateInput, maxLength, required, showNotification, TextInput, translate} from 'react-admin';
import {Redirect} from 'react-router-dom';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import {HsGioiInput} from "./HsGioiInput";
import {MonChuyenInput} from "./MonChuyenInput";
import {SwimTypeInput} from "../../components/SwimType";
import {compose} from "redux";
import {connect} from "react-redux";
import withStyles from '@material-ui/core/styles/withStyles';
const styles = {
    button: {
        margin: 1,
    },
    selectArray: {
        minWidth: '90%',
    },
    width90: {
        width: '90%',
    },
    label: {fontWeight: 'bold', fontSize: 16},
    cancelBtn: {
        marginLeft: 20
    },
    checkboxGroup: {
        "& > div ": {
            flexDirection: 'column',
        }
    },
    customCheckBox: {
        "& > div > label ": {
            width: '100%'
        }
    }
};

const nguyenVong1s = [
    'Không',
    'Toán',
    'Lý',
    'Hoá - Sinh',
    'Tin',
    'Văn',
    'Anh XH',
    'Anh TN'

]
const nguyenVong2s = [
    'Lý - Hóa',
    'Hoá - Sinh',
    'Lý - Sinh',
    'Địa - GDKTPL',
    'TICHHOP',
]

const chuyenDeHocTaps = [
    'CĐ Lý',
    'CĐ Hóa',
    'CĐ Sinh',
    'CĐ Tin',
    'CĐ Sử',
    'CĐ Địa',
    'CĐ KTPL',
    'TICHHOP'
]
const chuyenDeHocTap2 = [
    'Trống',
    'CĐ Lý',
    'CĐ Hóa',
    'CĐ Sinh',
    'CĐ Tin',
    'CĐ Sử',
    'CĐ Địa',
    'CĐ KTPL',
    'TICHHOP'

]

const nhomMon3Options = [
    'Lý',
    'Hoá',
    'Sinh',
    'Địa',
    'KTPL',
    'Công nghệ CN',
    'Công nghệ NN',
    'TICHHOP'
]
const nhomMon3Options2 = [
    'Trống',
    'Lý',
    'Hoá',
    'Sinh',
    'Địa',
    'KTPL',
    'Công nghệ CN',
    'Công nghệ NN',
    'TICHHOP'

]
const nhomMon4Options = [
    'Tin',
    'Âm nhạc',
    'Mỹ thuật'
]
const nhomMon4Options2 = [
    'Trống',
    'Tin',
    'Âm nhạc',
    'Mỹ thuật'
]
const AdmissionSubjectRegistered2Fields = props => {
    const [values, setValues] = React.useState({
        isRedirect: false,
        refreshList: false,
        openWhiteList: false,
        units: [],
        selectedElectives: []
    });
    const {
        defaultValue,
        save,
        programServices,
        schoolServices,
        setSchoolServices,
        setProgramServices, nhomMon3, nhomMon4, chuyenDeHocTap, haveTinHoc
    } = props;

    const [canSwim, setCanSwim] = useState(false)

    useEffect(() => {
        if (!defaultValue.isRedirect) {
            setValues({...values})
        } else {
            setValues({isRedirect: true, refreshList: true});
        }
    }, [defaultValue.isRedirect]);
    useEffect(() => {
        if (defaultValue.ready) {
            setCanSwim(defaultValue.canSwim)
        }
    }, [defaultValue.ready]);
    const changeProgramService = (index) => {
        const arr = [...programServices]
        arr[index].selected = !arr[index].selected
        setProgramServices(arr)
    }

    const changeSchoolService = (index) => {
        const arr = [...schoolServices]
        arr[index].selected = !arr[index].selected
        setSchoolServices(arr)
    }

    const changeCanSwim = () => {
        setCanSwim(!canSwim)
        props.onDirectChange('canSwim', !canSwim)
    }

    function cancel() {
        setValues({isRedirect: true, refreshList: false});
    }

    if (values.isRedirect) {
        return <Redirect to={'/admissionChuyens?refreshView=' + values.refreshList}/>;
    } else {
        return (
            <React.Fragment>
                <Grid item xs={12} sm={4}>
                    <TextInput source="sbd" label="resources.admissionChuyens.fields.sbd" disabled/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInput source="customerName" label="resources.admissionChuyens.fields.customerName"
                               disabled/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInput source="loaiTrungTuyen"
                               label="resources.admissionChuyens.fields.loaiTrungTuyen" disabled/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <MonChuyenInput source="monChuyen"
                                    label="resources.admissionChuyens.fields.monChuyen"
                                    validate={[required()]}
                                    onChange={(e, v) => props.onDirectChange('monChuyen', v)}
                                    style={styles.width90}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInput source="diemChuyen"
                               label="resources.admissionChuyens.fields.diemChuyen" disabled/>
                </Grid>
                <Grid item xs={12} sm={4}>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <HsGioiInput source="hsGioiTp"
                                 label="resources.admissionChuyens.fields.hsGioiTp"
                                 validate={[required()]}
                                 onChange={(e, v) => props.onDirectChange('hsGioiTp', v)}
                                 style={styles.width90}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInput source="giaiHsGioi"
                               onChange={props.onChange('giaiHsGioi')}
                               label="resources.admissionChuyens.fields.giaiHsGioi"
                               validate={maxLength(150, 'Không quá 150 ký tự')}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInput source="giaiKhac" label="resources.admissionChuyens.fields.giaiKhac"
                               onChange={props.onChange('giaiKhac')} style={styles.width90}
                               validate={maxLength(150, 'Không quá 150 ký tự')}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInput source="documentNumber" label="resources.admissions.fields.documentNumber"
                               onChange={props.onChange('documentNumber')}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <DateInput source="documentIssueDate"
                               label="resources.admissions.fields.documentIssueDate"
                               onChange={(e, v) => props.onDirectChange('documentIssueDate', v)}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextInput source="documentOrigin" label="resources.admissions.fields.documentOrigin"
                               onChange={props.onChange('documentOrigin')}/>
                </Grid>

                {defaultValue.loaiTrungTuyen == 'TICHHOP' ?
                    <>
                        <Grid item xs={12} sm={12}>
                            <span style={styles.label}>Nhóm môn lựa chọn 4*</span>
                        </Grid>
                        {nhomMon4.map((item, index) => (
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <span>{'Ưu tiên ' + (index + 1)}</span>
                                    <Select
                                        labelId={"mon-4" + index}
                                        id={"mon-4-select" + index}
                                        value={item.subjectName}
                                        label={false}
                                        onChange={(e) => props.changeNhomMon4(index, e.target.value)}
                                    >
                                        {nhomMon4Options.map((el, index) => (
                                            <MenuItem value={el}>{el}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        ))
                        }
                    </>
                    :
                    <>
                        {/*<Grid item xs={12} sm={12}>*/}
                        {/*    <NV1Input source="nguyenVong1"*/}
                        {/*                   label="resources.admissions.fields.nguyenVong1"*/}
                        {/*                   validate={[required()]}*/}
                        {/*                   onChange={(e, v) => props.onDirectChange('nguyenVong1', v)}*/}
                        {/*                   style={styles.width90}/>*/}
                        {/*</Grid>*/}
                        <FormControl fullWidth>
                            <span style={styles.label}>Nguyện vọng 1*</span>
                            <Select
                                labelId={"nv1"}
                                id={"nv1-select"}
                                value={defaultValue.nguyenVong1}
                                onChange={(e) => props.onDirectChange('nguyenVong1', e.target.value)}
                            >
                                {nguyenVong1s.map((el, index) => (
                                    <MenuItem value={el}>{el}</MenuItem>
                                ))
                                }
                            </Select>
                        </FormControl>
                        <FormControl fullWidth>
                            <span style={styles.label}>Nguyện vọng 2*</span>
                            <Select
                                labelId={"nv2"}
                                id={"nv2-select"}
                                value={defaultValue.nguyenVong2}
                                onChange={(e) => props.onDirectChange('nguyenVong2', e.target.value)}
                            >
                                {nguyenVong2s.map((el, index) => (
                                    <MenuItem value={el}>{el}</MenuItem>
                                ))
                                }
                            </Select>
                        </FormControl>
                        <Grid item xs={12} sm={12}>
                            <span style={styles.label}>Nhóm môn lựa chọn 3*</span>
                        </Grid>
                        {nhomMon3.map((item, index) => (
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <span>{'Ưu tiên ' + (index + 1)}</span>
                                    {index > 0 ?
                                        <Select
                                            labelId={"mon-3" + index}
                                            id={"mon-3-select" + index}
                                            value={item.subjectName}
                                            label={false}
                                            onChange={(e) => props.changeNhomMon3(index, e.target.value)}
                                        >
                                            {nhomMon3Options2.map((el, index) => (
                                                <MenuItem value={el}>{el}</MenuItem>
                                            ))}
                                        </Select>
                                        :
                                        <Select
                                            labelId={"mon-3" + index}
                                            id={"mon-3-select" + index}
                                            value={item.subjectName}
                                            label={false}
                                            onChange={(e) => props.changeNhomMon3(index, e.target.value)}
                                        >
                                            {nhomMon3Options.map((el, index) => (
                                                <MenuItem value={el}>{el}</MenuItem>
                                            ))}
                                        </Select>
                                    }
                                </FormControl>
                            </Grid>
                        ))
                        }
                        <Grid item xs={12} sm={12}>
                            <span style={styles.label}>Nhóm môn lựa chọn 4*</span>
                        </Grid>
                        {nhomMon4.map((item, index) => (
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <span>{'Ưu tiên ' + (index + 1)}</span>
                                    {index > 0 ?
                                        <Select
                                            labelId={"mon-4" + index}
                                            id={"mon-4-select" + index}
                                            value={item.subjectName}
                                            label={false}
                                            onChange={(e) => props.changeNhomMon4(index, e.target.value)}
                                        >
                                            {nhomMon4Options2.map((el, index) => (
                                                <MenuItem value={el}>{el}</MenuItem>
                                            ))}
                                        </Select>
                                        :
                                        <Select
                                            labelId={"mon-4" + index}
                                            id={"mon-4-select" + index}
                                            value={item.subjectName}
                                            label={false}
                                            onChange={(e) => props.changeNhomMon4(index, e.target.value)}
                                        >
                                            {nhomMon4Options.map((el, index) => (
                                                <MenuItem value={el}>{el}</MenuItem>
                                            ))}
                                        </Select>
                                    }
                                </FormControl>
                            </Grid>
                        ))
                        }
                        <Grid item xs={12} sm={12}>
                            <span style={styles.label}>Nhóm Cụm chuyên đề học tập*</span>
                        </Grid>
                        {chuyenDeHocTap.map((item, index) => (
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <span>{'Ưu tiên ' + (index + 1)}</span>
                                    {index > 0 ?
                                        <Select
                                            labelId={"chuyen_de" + index}
                                            id={"chuyen_de-select" + index}
                                            value={item.name}
                                            label={false}
                                            onChange={(e) => props.changeChuyenDeHocTap(index, e.target.value)}
                                        >
                                            {chuyenDeHocTap2.map((el, index) => (
                                                <MenuItem value={el}>{el}</MenuItem>
                                            ))}
                                        </Select>
                                        :
                                        <Select
                                            labelId={"chuyen_de" + index}
                                            id={"chuyen_de-select" + index}
                                            value={item.name}
                                            label={false}
                                            onChange={(e) => props.changeChuyenDeHocTap(index, e.target.value)}
                                        >
                                            {chuyenDeHocTaps.map((el, index) => (
                                                <MenuItem value={el}>{el}</MenuItem>
                                            ))}
                                        </Select>
                                    }
                                </FormControl>
                            </Grid>
                        ))
                        }
                    </>
                }
                <Grid item xs={12} sm={12}>
                        <span
                            style={styles.label}>{'Đăng ký chương trình với nhà trường'}</span>
                </Grid>
                {programServices.map((item, index) => (
                    <>
                        {defaultValue.loaiTrungTuyen == 'TICHHOP' ?
                            <>
                                {!item.name.toLowerCase().startsWith('tiếng anh') &&
                                    <>
                                        {item.name.toLowerCase().startsWith('tin học') ?
                                            <Grid item xs={12} sm={4}>
                                                <FormControlLabel
                                                    labelPlacement="start"
                                                    control={<Switch checked={item.selected || haveTinHoc}
                                                                     onChange={() => !haveTinHoc && changeProgramService(index)}/>}
                                                    label={item.name}
                                                />
                                            </Grid>
                                            :
                                            <Grid item xs={12} sm={4}>
                                                <FormControlLabel
                                                    labelPlacement="start"
                                                    control={<Switch checked={item.selected}
                                                                     onChange={() => !item.forced && changeProgramService(index)}/>}
                                                    label={item.name}
                                                />
                                            </Grid>
                                        }
                                    </>
                                }
                            </>
                            :
                            <>
                                {item.name.toLowerCase().startsWith('tin học') ?
                                    <Grid item xs={12} sm={4}>
                                        <FormControlLabel
                                            labelPlacement="start"
                                            control={<Switch checked={item.selected || haveTinHoc}
                                                             onChange={() => !haveTinHoc && changeProgramService(index)}/>}
                                            label={item.name}
                                        />
                                    </Grid>
                                    :
                                    <Grid item xs={12} sm={4}>
                                        <FormControlLabel
                                            labelPlacement="start"
                                            control={<Switch checked={item.selected}
                                                             onChange={() => !item.forced && changeProgramService(index)}/>}
                                            label={item.name}
                                        />
                                    </Grid>
                                }
                            </>
                        }
                    </>
                ))
                }
                <Grid item xs={12} sm={12}>
                    <span style={styles.label}>{'Các dịch vụ giáo dục'}</span>
                </Grid>
                {schoolServices.map((item, index) => (
                    <Grid item xs={12} sm={4}>
                        <FormControlLabel
                            labelPlacement="start"
                            control={<Switch checked={item.selected}
                                             onChange={() => !item.forced && changeSchoolService(index)}/>}
                            label={item.name}
                        />
                    </Grid>
                ))
                }
                <Grid item xs={12} sm={12}>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <SwimTypeInput source="canSwim"
                                   label="resources.admissions.fields.canSwim"
                                   validate={[required()]}
                                   onChange={(e, v) => props.onDirectChange('canSwim', v)}
                                   style={styles.width90}/>
                </Grid>
                {!!defaultValue.canSwim &&
                    <>
                        <Grid item xs={12} sm={3}>
                            <TextInput source="swimCertificate"
                                       label="resources.admissionChuyens.fields.swimCertificate"
                                       onChange={props.onChange('swimCertificate')} style={styles.width90}
                                       validate={[required(), maxLength(50, 'Không quá 50 ký tự')]}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextInput source="swimPlaceOfCertificate"
                                       label="resources.admissionChuyens.fields.swimPlaceOfCertificate"
                                       onChange={props.onChange('swimPlaceOfCertificate')} style={styles.width90}
                                       validate={[required(), maxLength(50, 'Không quá 50 ký tự')]}/>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <DateInput source="swimDateOfCertificate"
                                       label="resources.admissions.fields.swimDateOfCertificate"
                                       validate={[required()]}
                                       onChange={(e, v) => props.onDirectChange('swimDateOfCertificate', v)}/>
                        </Grid>
                    </>
                }

                <Grid item xs={12} sm={12} style={{marginTop: 15}}>
                    <Button variant="contained"
                            color="primary"
                            style={styles.button}
                            disabled={defaultValue.saveDisabled}
                            onClick={save}>
                        <SaveIcon/> Lưu
                    </Button>
                    <Button variant="contained" style={styles.cancelBtn}
                            onClick={cancel}>
                        <CancelIcon/> Hủy
                    </Button>
                </Grid>
            </React.Fragment>
        )
    }
}

export default compose(translate, connect(null, {showNotification}), withStyles(styles))(AdmissionSubjectRegistered2Fields)
